import { Component } from 'preact';
import style from './style';

import { themes } from './../../../config'
import SocialIcons from '../../social'
export default class TmplIntro extends Component {
	render(props, state) {
		let templateTheme = this.props.template && this.props.template.template_bg_color || 'light'
    let themeConfig = themes.variants[templateTheme]

		return (
			<div class={'ottTemplate'}>
				<div class={'ottTemplateContainer intro'}>
					<div class={'introCardWrapper'}>
            <h1 class={'videoTitle'}
								dangerouslySetInnerHTML={{__html: props.title.toString().toLowerCase()}} />
            <p class={'videoDescription'} dangerouslySetInnerHTML={{__html: props.desc}} />
					</div>

					<SocialIcons icons={props.social} destroyTag={this.props.destroyTag} template={this.props.template} />
				</div>
      </div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/spareparts/templates/intro/index.js